import { atom } from 'jotai';
import type { RemainingItem } from '../../../modernization-common/side-panel-m4/remaining-items/v2/types';
import { computeLabelConstraintViolations } from '../utils/label-constraint-validation-utils';
import { annotationLabelsAtom, annotationMetadataAtom } from './annotation-atoms';
export const labelConstraintRemainingItemsAtom = atom<RemainingItem[]>(get => {
  const annotationLabels = get(annotationLabelsAtom);
  const metadata = get(annotationMetadataAtom);
  const annotationCountByLabel = new Map<string, number>();
  for (const [, metadataPayload] of metadata) {
    const currentCount = annotationCountByLabel.get(metadataPayload.labelId) ?? 0;
    annotationCountByLabel.set(metadataPayload.labelId, currentCount + 1);
  }
  return computeLabelConstraintViolations(annotationLabels, annotationCountByLabel);
});